

const RootReducer = (state = {}, action) => {
  const {type, res} = action;
  
  switch (type) {
    case 'SET_MOB_VERIFICATION_GENERATE_OTP': {
      return {
        ...state,
        mobVerificationGenerateOtpRes: res
      };
    }
    case 'SET_MOB_VERIFICATION_VERIFY_FORCE_OTP': {
      return {
        ...state,
        mobVerificationVerifyForceOtpRes: res
      };
    }
    case 'SET_MOB_VERIFICATION_RESEND_OTP': {
      return {
        ...state,
        mobVerificationResendOtpRes: res
      };
    }
    case 'SET_MOB_VERIFICATION_VERIFY_OTP': {
      return {
        ...state,
        mobVerificationVerifyOtpRes: res
      };
    }
    case 'SET_EMAIL_VERIFICATION_OTP': {
      return {
        ...state,
        emailVerificationOtpRes: res
      };
    }
    case 'SET_CURRENT_STATE': {
      return {
        ...state,
        initData: res
      };
    }
    case 'UPDATE_KYC_TYPE_RES': {
      return {
        ...state,
        updateKycTypeDataRes: res
      };
    } 
    case 'SET_CONSENT_FORM': {
      return {
        ...state,
        consentData: res
      };
    }
    case 'CHECK_COMPLETED_STEPS': {
      return {
        ...state,
        completedStepsData: res
      };
    }
    case 'PAN_VERIFICATION_RES': {
      return {
        ...state,
        panVerificationDataRes: res
      };
    }
    case 'USER_PAN_NAME_UPDATE_RES': {
      return {
        ...state,
        panNameDataRes: res
      };
    }
    case 'CKYC_RES': {
      return {
        ...state,
        cKycRes: res
      }
    }
    case 'SET_LIMITED_KYC': {
      return {
        ...state,
        isLimitedKyc: res
      }
    }
    case 'SET_CAPTCHA_RES': {
      return {
        ...state,
        captchaRes: res
      };
    }
    case 'SET_OTP_RES': {
      return {
        ...state,
        otpRes: res
      };
    }
    case 'OTP_MAX_LIMIT_EXCEEDED_RES': {
      return {
        ...state,
        otpMaxLimitExceededData: res
      };
    }
    case 'SUBMIT_OTP_RES': {
      return {
        ...state,
        submitOTPData: res
      };
    }
    case 'SUBMIT_OTP_FAILED_RES': {
      return {
        ...state,
        submitOTPFailedData: res
      };
    }
    case 'SET_VIDEO_LINK_RES': {
      return {
        ...state,
        videoLinkData: res
      };
    }
    case 'PHOTO_RES': {
      return {
        ...state,
        photoDataRes: res
      };
    }
    case 'POI_RES': {
      return {
        ...state,
        poiDataRes: res
      };
    }
    case 'POA_RES': {
      return {
        ...state,
        poaDataRes: res
      };
    }
    case 'ZIP_CODE_DATA_RES': {
      return {
        ...state,
        zipCodeDataRes: res
      };
    }
    case 'GET_POA_LOCAL': {
      return {
        ...state,
        poaDataLocal: res
      };
    }
    case 'CONFIRM_AADHAAR_XML_RES': {
      return {
        ...state,
        confirmAadhaarXmlDataRes: res
      };
    }
    case 'SAVE_USER_LOCATION_RES': {
      return {
        ...state,
        userLocationRes: res
      };
    }
    case 'CHECK_PHOTO_LIVENESS_RES': {
      return {
        ...state,
        photoLivenessRes: res
      };
    }
    case 'CHECK_PHOTO_LIVENESS_FAILED_RES': {
      return {
        ...state,
        photoLivenessFailedRes: res
      };
    } 
    case 'CHECK_DOCUMENT_PHOTO_LIVENESS_RES': {
      return {
        ...state,
        documentPhotoLivenessRes: res
      };
    }  
    case 'TOGGLE_PAGE_EDIT': {
      return {
        ...state,
        isPageEdited: res
      };
    }
    case 'OPEN_CANCEL_PROCESS_DIALOG': {
      return {
        ...state,
        cancelProcessDialog: res
      };
    }
    case 'CONFIRM_CKYC_ADDRESS_RES': {
      return {
        ...state,
        confirmCkycAddressDataRes: res
      };
    }
    case 'HIDE_CKYC_VERIFICATION': {
      return {
        ...state,
        hideCkycVerificationRes: res
      };
    }
    case 'GENERATE_KARZA_OTP_RES': {
      return {
        ...state,
        karzaOtpDataRes: res
      };
    }
    case 'KARZA_RES': {
      return {
        ...state,
        karzaDataRes: res
      };
    }
    case 'KYC_DECLINED_KYC0001': {
      return {
        ...state,
        kycDeclinedRes: res
      };
    }
    case 'QUICK_KYC_GENERATE_OTP_RES': {
      return {
        ...state,
        quickKycGenerateOtpDataRes: res
      };
    }
    case 'QUICK_KYC_VALIDATE_OTP_RES': {
      return {
        ...state,
        quickKycValidateOtpDataRes: res
      };
    }
    case 'QUICK_KYC_VERIFY_RES': {
      return {
        ...state,
        quickKycVerifyDataRes: res
      };
    }
    case 'QUICK_KYC_VERIFY_FAIL_RES': {
      return {
        ...state,
        quickKycVerifyFailDataRes: res
      };
    }
    case 'OLD_CKYC_MSG': {
      return {
        ...state,
        oldCKycMsgRes: res
      };
    }
    case 'CANCEL_VIDEO_KYC_DIALOG': {
      return {
        ...state,
        cancelVideoKycDialogRes: res
      };
    }
    case 'CONFIRM_ADDITIONAL_FIELDS_RES': {
      return {
        ...state,
        confirmAdditionalFieldsDataRes: res
      };
    }
    case 'IS_FROM_DETAILS_PAGE': {
      return {
        ...state,
        isFromDetailsPageRes: res
      };
    }
    case 'CREATE_CIF_RES': {
      return {
        ...state,
        cifDataRes: res
      };
    }
    case 'VERIFY_PENNY_DROP_RES': {
      return {
        ...state,
        pennyDropRes: res
      };
    }
    case 'FETCH_META_FIELDS_RES': {
      return {
        ...state,
        metaFieldsRes: res
      };
    }
    case 'HDFC_VKYC_PAN_VERIFICATION_RES': {
      return {
        ...state,
        hdfcVkycPanVerificationDataRes: true
      }
    }

    /////////////// HDFC BANK VKYC KYC
    case 'HDFC_VKYC_ADDITIONAL_DATA_RES': {
      return {
        ...state,
        hdfcVkycAdditionalDataRes: res
      };
    }

    case 'HDFC_BANK_EKYC_RES': {
      return {
        ...state,
        hdfcBankEKycDataRes: res
      };
    }
    case 'HDFC_BANK_STEP_DETAILS_RES': {
      return {
        ...state,
        hdfcBankStepDetailsDataRes: res
      };
    }

    case 'HDFC_BANK_VKYC_USER_DETAILS_RES': {
      return {
        ...state,
        hdfcBankUserDetailsDataRes: res
      };
    }
    case 'HDFC_BANK_ADDRESS_CONFIRMATION_RES': {
      return {
        ...state,
        hdfcBankAddressConfirmationRes: res
      };
    }
    case 'HDFC_VKYC_CONSENT_RES': {
      return {
        ...state,
        hdfcVkycConsentRes: res
      };
    }
    
    case 'HDFC_BANK_VKYC_RES': {
      return {
        ...state,
        hdfcBankVKycDataRes: res
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
};

export default RootReducer;
